import React, { useLayoutEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { logout } from 'utils/Session';

const Login = props => {
  let navigate = useNavigate();

  useLayoutEffect(() => {
    async function logoutAndNavigateToLogin() {
      await logout();
      await navigate("/auth/login");
    }
    logoutAndNavigateToLogin();
  })
  return (
    <></>
  );
}

export default Login;
